import { PaymentCardImageTypes } from '@mews/framework';

export const getSourceImageByType = (type: keyof PaymentCardImageTypes) => `${type}.svg`;
